import { InputLabel, MenuItem, Select, Typography } from "@mui/material"
import { CssField } from "@shared/ui/mui-input/MuiInput.styled"
import { Controller, UseFormReturn, Path, PathValue, FieldValues } from "react-hook-form"
import { DocumentSettings } from "../../../../models/document-settings"
import { DocumentStructure } from "../../../../models/document-structure"
import MuiInput from "@shared/ui/mui-input/MuiInput"


type DocFormValues = {
  document_settings_id: number;
  document_number: number;
};

interface HeaderProps<T extends FieldValues & DocFormValues> {

    method: "add" | "edit";

    documentForm: UseFormReturn<T>;

    documentsSettings: DocumentSettings[];
    settings: DocumentSettings;
    structure: DocumentStructure[];

    isDocumentClosed?: boolean;
}


function Header<T extends FieldValues & DocFormValues>({ method, documentForm, documentsSettings, settings, structure, isDocumentClosed }: HeaderProps<T>) {

    

    return (
        <div className="head">
            <div className="select-document">

                <CssField>
                    <InputLabel>סוג מסמך</InputLabel>

                    <Controller

                        name={"document_settings_id" as Path<T>}
                        control={documentForm.control}
                        defaultValue={settings.id as PathValue<T, Path<T>>}

                        render={({ field: { onChange, value } }) => (
                            <Select
                                value={value}
                                onChange={onChange}
                                id={"document_settings_id"}
                                disabled={method==="edit"}
                            >
                                {
                                    documentsSettings.map((documentSettings, index) => (
                                        <MenuItem key={index} value={documentSettings.id}>{documentSettings.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        )}
                    />
                </CssField>


            </div>
            <div className="document-number">
                <Typography variant="body1" component="div" sx={{ color: !isDocumentClosed ? "text.primary" : "action.disabled" }}>
                    מספר {documentForm.getValues("document_number" as Path<T>)}
                </Typography>
            </div>
            <div className="inputs">
                {structure?.map((field, index) => {
                    return field.type === "תאריך ושעה" ? <MuiInput key={`${field.field_name}${index}`} field={field} variant='outlined' useForm={documentForm} showRequired dateToNow={method==="add"} disabled={isDocumentClosed}/> : null
                })}
            </div>
        </div>
    )    

}

export default Header